import React, { useState } from 'react';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';
import Select from '../../../../shared/select';

const TRIP_STATUSES = [
    { label: 'Active', value: 'active' },
    { label: 'Scheduled', value: 'scheduled' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'cancelled' },
];

interface IChangeStatusModal {
    open: boolean;
    onClose: () => void;
    currentStatus?: string;
    onConfirm: (status: string) => void;
    isLoading?: boolean;
}

const ChangeStatusModal = ({
    open,
    onClose,
    currentStatus,
    onConfirm,
    isLoading = false
}: IChangeStatusModal) => {
    const [selectedStatus, setSelectedStatus] = useState<string>(currentStatus || '');

    React.useEffect(() => {
        if (open) {
            // Normalize 'closed' to 'cancelled' for display
            const normalizedStatus = currentStatus === 'closed' ? 'cancelled' : (currentStatus || '');
            setSelectedStatus(normalizedStatus);
        }
    }, [open, currentStatus]);

    const handleConfirm = () => {
        if (selectedStatus) {
            onConfirm(selectedStatus);
        }
    };

    return (
        <Modal
            open={open}
            title="Change Trip Status"
            onClose={onClose}
            contentContainerStyle="!rounded-xl min-w-[90%] md:min-w-[480px]"
        >
            <div className="p-4">
                <p className="mb-4 text-sm dark:text-primary-darkMode">
                    Select a new status for this trip:
                </p>
                <Select
                    value={selectedStatus}
                    options={TRIP_STATUSES}
                    placeholder="Select status"
                    showValue={true}
                    onChangeSelectValue={(e) => setSelectedStatus(e?.target?.value || '')}
                    className="mb-4"
                />
                <div className="flex items-center justify-end gap-2 mt-6">
                    <Button
                        label="Cancel"
                        className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800 dark:text-primary-darkMode"
                        onClickButton={onClose}
                        disabled={isLoading}
                    />
                    <Button
                        label={isLoading ? 'Updating...' : 'Update Status'}
                        className="btn-primary !px-4"
                        onClickButton={handleConfirm}
                        disabled={!selectedStatus || isLoading || selectedStatus === currentStatus}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ChangeStatusModal;
